<template>
  <div class="form_con">
    <h3>徐州市主城区住宅房屋征收购房卡</h3>
    <h4>No:{{cardInfo.cardSn}}</h4>
    <van-form>
      <van-field v-model="cardInfo.personName" label="被征收人姓名" readonly/>
      <van-field v-model="cardInfo.cardNo" label="身份证号" readonly/>
      <van-field v-model="cardInfo.itemName" label="征收项目名称" readonly/>
      <van-field v-model="cardInfo.expropriateNo" label="征收编号" readonly/>
      <van-field v-model="cardInfo.linkTel" label="联系电话" readonly/>
      <van-field v-model="cardInfo.emergencyCall" label="紧急联系电话" readonly/>
      <van-field v-model="cardInfo.houseValuation" label="被征收房屋评估价款" readonly/>
      <van-field v-model="cardInfo.subsidyAmount" label="最高购房补贴金额" readonly/>
      <van-field v-model="cardInfo.serviceDate" label="使用期限" readonly/>
      <van-field v-model="cardInfo.intentHouseInfo" label="意向房屋信息" readonly/>
      <van-field v-model="cardInfo.grantDate" label="发卡日期" readonly/>
    </van-form>
  </div>
</template>

<script>

export default {
  data() {
    return {
      cardInfo:{
        cardSn:'',
        personName:'',
        cardNo:'',
        itemName:'',
        expropriateNo:'',
        linkTel:'',
        emergencyCall:'',
        houseValuation:'',
        subsidyAmount:'',
        serviceDate:'',
        intentHouseInfo:'',
        grantDate:'',
      },
    };
  },
  mounted() {
    const id = this.$route.params.id;
    this.queryCardInfo(id)
  },
  methods: {
    queryCardInfo(id) {
      var params = {};
      params.id = id;
      this.$http({
        // url: "house/api/ysbm/subsidyCardInfo.do",
        url: "http://localhost:8080/house/api/ysbm/subsidyCardInfo.do",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: params,
      })
        .then((res) => {
          if (res.success) {
            var obj = res.obj;
            var personList = obj.personList;
            var person = personList[0];
            obj.personName = person.personName;
            obj.cardNo = person.cardNo;
            obj.houseValuation = obj.houseValuation+'元';
            obj.subsidyAmount = obj.subsidyAmount+'元';
            var serviceBegin = obj.serviceBegin.substring(0,10);
            var serviceEnd = obj.serviceEnd.substring(0,10);
            obj.serviceDate = serviceBegin+' 至 '+serviceEnd;
            this.cardInfo = obj;
          } else {
            this.$toast(res.msg);
          }
        })
        .catch(() => {
          this.$toast("查询失败");
        });
    },
  },
};
</script>
<style lang="less" scoped>

h3 {
  font-size: 0.36rem;
  font-weight: 800;
  padding: 0 16px;
  margin: 0.5rem auto 0.25rem;
  text-align: center;
}

h4 {
  font-size: 0.25rem;
  font-weight: 600;
  text-align: right;
  padding-right: 25px;
  margin-bottom: 0.4rem;
}

.form_con {
  padding: 0.3rem 0rem;
}

</style>
